import React, { useState, useEffect } from 'react';
import { useLocationDetails } from '~hooks/useLocationDetails';
import cx from 'classnames';

import OperationsAddress from '~containers/operations/address';
import OperationsFields from '~containers/operations/fields';
import Loader from '~components/loader';

const OperationsForm = ({ operations, onSubmit = () => {}, isSubmitting }) => {
  const [showFields, setShowFields] = useState(false);
  const [isLoadingInitial, setIsLoadingInitial] = useState(true);
  const [defaultPrice, setDefaultPrice] = useState(operations?.minimumRate?.amount || null);

  const { locationDetails, pricingDetails, isLoading, requestLocationByID } = useLocationDetails(
    operations.address?.place_id || null
  );

  useEffect(() => {
    if (!isLoading) {
      setIsLoadingInitial(false);
    }
  }, [isLoading]);

  useEffect(() => {
    if (locationDetails && pricingDetails) {
      if (!defaultPrice) {
        setDefaultPrice((pricingDetails.maxPrice - pricingDetails.minPrice) * 0.25 + pricingDetails.minPrice);
      }
      setShowFields(true);
    }
  }, [locationDetails, pricingDetails]);

  const handleAddressSubmit = (newAddress) => {
    requestLocationByID(newAddress.place_id);
  };

  const handleSubmit = (newOperations) => {
    const operationsToSubmit = {
      ...newOperations,
      address: locationDetails,
    };
    onSubmit(operationsToSubmit);
  };

  return (
    <div className={cx('c-form--intake', {'c-form--intake-show-fields': showFields})}>
      <OperationsAddress
        defaultAddress={locationDetails || operations.address}
        onSubmit={handleAddressSubmit}
        isDataLoading={isLoadingInitial}
      />
      {!showFields && isLoading ? (
        <div className="l-center l-mt2">
          <Loader />
        </div>
      ) : null}
      {showFields && (
        <OperationsFields
          operations={operations}
          pricingDetails={pricingDetails}
          defaultPrice={defaultPrice}
          translationsContext="intake"
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default OperationsForm;
